import { useQuery } from 'react-query';
import { Axios } from '@utils/api/axios-instance.ts';
import { GET_URL } from '@utils/api/endpoints.ts';
import { BurnInJobResponse } from './use-start-burn-in-export';

type BurnInStatusParams = {
  sessionId: string;
  documentId: string;
  enabled: boolean;
};

async function fetchBurnInStatus(
  sessionId: string,
  documentId: string
): Promise<BurnInJobResponse> {
  const { data } = await Axios.get<BurnInJobResponse>(
    GET_URL(sessionId, documentId).documentBurnIn
  );
  return data;
}

export function useBurnInJobStatus({
  sessionId,
  documentId,
  enabled
}: BurnInStatusParams) {
  return useQuery<BurnInJobResponse>(
    ['burn-in-job-status', sessionId, documentId],
    () => fetchBurnInStatus(sessionId, documentId),
    {
      enabled,
      refetchInterval: data => {
        if (!data) return 5000;
        if (data.status === 'ready' || data.status === 'failed') return false;
        return 5000; // Poll every 5 seconds while queued/processing
      },
      refetchIntervalInBackground: false,
      retry: false
    }
  );
}
